import React from "react";
import UsersListPanel from "./UsersListPanel";
import Modal from "./UsersModal";
import useUsersLoad from "./useUsersLoad";
import Select from "./UsersSelect";
import Swal from "sweetalert2";
import { Button, Form, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  tambahSupervisor,
  tambahAksesSupervisor,
  getAllSupervisor,
  getAllClient,
  hapusAksesSupervisor,
} from "stores";
import { getAllCabang } from "stores";
import { penempatanSupervisor } from "stores";
import { editStatusSupervisor } from "stores";
import { resetPassword } from "stores";

function ListSupervisor() {
  const dispatch = useDispatch();
  const listState = useUsersLoad(getAllSupervisor, dispatch);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const storeClient = useSelector((state) => state.clientReducer);
  const supervisor = useSelector((state) => state.supervisorReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const auth = useSelector((state) => state.authReducer);

  const [modalSpv, setModalSpv] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalTambahAkses, setModalTambahAkses] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [nama, setNama] = React.useState("");
  const [nik, setNik] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listSpv, setListSpv] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClientSpv, setIdClientSpv] = React.useState("");
  const [listCabang, setListCabang] = React.useState([]);
  const [idCabang, setIdCabang] = React.useState(null);
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [idSupervisor, setIdSupervisor] = React.useState("");
  const [listDetailCabang, setListDetailCabang] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [status, setStatus] = React.useState("");

  const [pilihAkses, setPilihAkses] = React.useState("");
  const [aksesUser, setAksesUser] = React.useState([]);

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitSupervisor = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }
    tambahSupervisor({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClientSpv,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllSupervisor(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusSupervisor({
      idSupervisor: idSupervisor,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllSupervisor(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanSupervisor({
        idSupervisor: idSupervisor,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllSupervisor(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };
  const submitTambahAksesSupervisor = () => {
    if (!pilihAkses) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan akses tidak boleh kosong",
      });
    } else {
      tambahAksesSupervisor({
        idSupervisor: idSupervisor,
        akses: pilihAkses.value,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllSupervisor(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihCabang(null);
    setPilihAkses(null);
    setIdCabang(null);
    setPilihClient(null);
    setModalPenempatan(false);
    setModalTambahAkses(false);
    setModalSpv(false);
    setIdClientSpv("");
    setPilihClient("");
    setNik("");
    setNopeg("");
    setNama("");
  };

  React.useEffect(() => {
    let tmp =
      supervisor.listSupervisor &&
      supervisor.listSupervisor.map((val) => {
        const ubahPenempatan = val.penempatan != "";
        return {
          ...val,
          action: (
            <>
              <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Penempatan Supervisor</Tooltip>}
                >
                  <Button aria-label="Penempatan Supervisor" title="Penempatan Supervisor"
                    disabled={val.status !== "aktif"}
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: val.status !== "aktif" ? "#F1F5F9" : "#EFF6FF",
                      color: val.status !== "aktif" ? "#94A3B8" : "#3B82F6",
                      border: "none",
                      boxShadow: val.status !== "aktif" ? "none" : "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px",
                      cursor: val.status !== "aktif" ? "not-allowed" : "pointer",
                    }}
                    onMouseEnter={(e) => {
                      if (val.status === "aktif") {
                        e.currentTarget.style.backgroundColor = "#3B82F6";
                        e.currentTarget.style.color = "#FFFFFF";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (val.status === "aktif") {
                        e.currentTarget.style.backgroundColor = "#EFF6FF";
                        e.currentTarget.style.color = "#3B82F6";
                      }
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdSupervisor(val._id);
                      setPilihCabang(null);
                      setIdCabang(null);
                      getAllCabang(dispatch, { idClient: val.idClient });
                      setModalPenempatan(!modalPenempatan);
                    }}
                  >
                    <i className="fas fa-map-marked-alt"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Tambah Akses</Tooltip>}
                >
                  <Button aria-label="Tambah Akses" title="Tambah Akses"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#FDF4FF",
                      color: "#C026D3",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#C026D3";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#FDF4FF";
                      e.currentTarget.style.color = "#C026D3";
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdSupervisor(val._id);
                      setPilihAkses("");
                      setModalTambahAkses(true);
                      setAksesUser(val.akses);
                    }}
                  >
                    <i className="fas fa-user-cog"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Edit Status</Tooltip>}
                >
                  <Button aria-label="Edit Status" title="Edit Status"
                    disabled={
                      !(val.penempatan?.length === 1 && !val.penempatan[0].namaCabang)
                    }
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: !(val.penempatan?.length === 1 && !val.penempatan[0].namaCabang) ? "#F1F5F9" : "#F1F5F9",
                      color: !(val.penempatan?.length === 1 && !val.penempatan[0].namaCabang) ? "#94A3B8" : "#0EA5E9",
                      border: "none",
                      boxShadow: !(val.penempatan?.length === 1 && !val.penempatan[0].namaCabang) ? "none" : "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px",
                      cursor: !(val.penempatan?.length === 1 && !val.penempatan[0].namaCabang) ? "not-allowed" : "pointer",
                    }}
                    onMouseEnter={(e) => {
                      if (val.penempatan?.length === 1 && !val.penempatan[0].namaCabang) {
                        e.currentTarget.style.backgroundColor = "#0EA5E9";
                        e.currentTarget.style.color = "#FFFFFF";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (val.penempatan?.length === 1 && !val.penempatan[0].namaCabang) {
                        e.currentTarget.style.backgroundColor = "#F1F5F9";
                        e.currentTarget.style.color = "#0EA5E9";
                      }
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdSupervisor(val._id);
                      setStatus("");
                      setModalEdit(true);
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Reset Password</Tooltip>}
                >
                  <Button aria-label="Reset Password" title="Reset Password"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#FEF2F2",
                      color: "#EF4444",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#EF4444";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#FEF2F2";
                      e.currentTarget.style.color = "#EF4444";
                    }}
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Reset Password",
                        text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Ya, Reset Password!",
                      });

                      if (result.isConfirmed) {
                        try {
                          const response = await resetPassword({
                            idUser: val._id,
                            role: val.role,
                          });

                          Swal.fire({
                            title: "Sukses",
                            text: response.data.message,
                            icon: "success",
                          });
                        } catch (error) {
                          Swal.fire({
                            title: "Error",
                            text: error.response.data.message,
                            icon: "error",
                          });
                        }
                      }
                    }}
                  >
                    <i className="fas fa-redo-alt"></i>
                  </Button>
                </OverlayTrigger>
              </div>
            </>
          ),
        };
      });
    setListSpv(tmp);
  }, [supervisor.listSupervisor]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });

    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          backgroundColor: "#FEE2E2",
          textColor: "#DC2626",
          icon: "fas fa-times-circle"
        };
      case "aktif":
        return {
          backgroundColor: "#DCFCE7",
          textColor: "#16A34A",
          icon: "fas fa-check-circle"
        };
      default:
        return {
          backgroundColor: "#F1F5F9",
          textColor: "#64748B",
          icon: "fas fa-info-circle"
        };
    }
  };

  const colSupervisor = [
    {
      name: "No",
      width: "80px",
      center: true,
      selector: (row, index) => index + 1,
    },
    {
      name: "Kode User",
      minWidth: "150px",
      center: true,
      selector: (row) => row.kodeUser,
    },
    {
      name: "No Karyawan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Nama",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Jabatan",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.role === "supervisor" ? "Supervisor" : "Supervisor",
    },
    {
      name: "BPD",
      minWidth: "200px",
      center: true,
      omit: auth.role === "super admin" ? false : true,
      selector: (row) => row.namaClient?.[0] || "—",
      // !row.penempatan?.length ? (
      //   <div style={{ fontWeight: "bold" }}>Belum Penempatan</div>
      // ) : (
      //   row.penempatan?.[0]?.namaClient
      // ),
    },
    {
      name: "Akses",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        !row.akses ? (
          <div style={{ fontWeight: "bold", color: "red" }}>
            Belum Memiliki Akses
          </div>
        ) : (
          <div
            style={{
              fontWeight: "bold",
              color: "blue",
              textTransform: "capitalize",
            }}
          >
            {row.akses.join(", ")}
          </div>
        ),
    },
    {
      name: "Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        !row.penempatan?.length || (row.penempatan.length === 1 && !row.penempatan[0]?.namaCabang) ? (
          <div style={{ fontWeight: "bold" }}>Belum Penempatan</div>
        ) : row.penempatan.length === 1 ? (
          row.penempatan?.[0]?.namaCabang
        ) : (
          <>
            <div>{row.penempatan?.[0]?.namaCabang},...</div>
            <button type="button" className="users-branch-link"
              onClick={() => {
                setSelectedUser(row);
                setListDetailCabang(row);
                setModalDetail(true);
              }}
            >Lihat semua cabang</button>
          </>
        ),
    },

    {
      name: "Status",
      minWidth: "150px",
      center: true,
      // selector: (row) => (row.status === "aktif" ? "Aktif" : "Tidak Aktif"),
      selector: (row) => row.status,
      cell: (row) => {
        const statusStyle = getStatusUser(row.status);
        const tampilanLabel = row.status === "aktif" ? "Aktif" : "Tidak Aktif";

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "600",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
            }}
          >
            <i className={statusStyle.icon}></i>
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "300px",
      omit: auth.role === "super admin" || auth.role === "admin" ? false : true,
      center: true,
      selector: (row) => row.action,
    },
  ];

  const listAkses = [
    { value: "", isDisabled: true },
    { label: "Konsumtif", value: "konsumtif" },
    { label: "Produktif", value: "produktif" },
  ];

  React.useEffect(() => { getAllClient(dispatch); }, [dispatch]);

  return (
    <>
      <Modal
        size="md"
        show={modalUbahPenempatan}
        onHide={() => {
          handleModalClose();
          setModalUbahPenempatan(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#FFFBEB", padding: "8px", borderRadius: "10px", color: "#D97706", display: "flex" }}>
                <i className="fas fa-exchange-alt"></i>
              </div>
              Form Ubah Penempatan Supervisor
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalUbahPenempatan(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  placeholder="Pilih Cabang..."
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#D97706" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalUbahPenempatan(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#D97706", border: "none", boxShadow: "0 4px 6px rgba(217, 119, 6, 0.2)", color: "white" }}
            >
              Simpan Perubahan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#EFF6FF", padding: "8px", borderRadius: "10px", color: "#3B82F6", display: "flex" }}>
                <i className="fas fa-info-circle"></i>
              </div>
              Detail Penempatan
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalDetail(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "16px", padding: "12px", backgroundColor: "#F8FAFC", borderRadius: "10px" }}>
                <div style={{ color: "#64748B", width: "100px", fontWeight: "600", fontSize: "14px" }}>Nama</div>
                <div style={{ color: "#1E293B", fontWeight: "700", fontSize: "14px", flex: 1 }}>{listDetailCabang.nama}</div>
              </div>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "16px", padding: "12px", backgroundColor: "#F8FAFC", borderRadius: "10px" }}>
                <div style={{ color: "#64748B", width: "100px", fontWeight: "600", fontSize: "14px" }}>Jabatan</div>
                <div style={{ color: "#1E293B", fontWeight: "700", fontSize: "14px", flex: 1 }}>{listDetailCabang.role === "supervisor" ? "Supervisor" : "Supervisor"}</div>
              </div>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "16px", padding: "12px", backgroundColor: "#F8FAFC", borderRadius: "10px" }}>
                <div style={{ color: "#64748B", width: "100px", fontWeight: "600", fontSize: "14px" }}>Penempatan</div>
                <div style={{ color: "#1E293B", fontWeight: "600", fontSize: "14px", flex: 1 }}>
                  <ul style={{ paddingLeft: "20px", margin: 0, display: "flex", flexDirection: "column", gap: "4px" }}>
                    {listDetailCabang.penempatan && listDetailCabang.penempatan.map((val, index) => (
                      <li key={index} style={{ color: "#3B82F6" }}>
                        <span style={{ color: "#1E293B" }}>{val.namaCabang}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </Modal.Body>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#EFF6FF", padding: "8px", borderRadius: "10px", color: "#3B82F6", display: "flex" }}>
                <i className="fas fa-map-marker-alt"></i>
              </div>
              Penempatan Supervisor
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalPenempatan(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  placeholder="Pilih Cabang..."
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#3B82F6" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalPenempatan(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitPenempatan}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#3B82F6", border: "none", boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)", color: "white" }}
            >
              Simpan Penempatan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-edit"></i>
              </div>
              Edit Status Supervisor
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalEdit(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Status</label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                  placeholder="Pilih status aktif/tidak aktif"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#0EA5E9" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalEdit(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              variant="primary"
              onClick={checkStatus}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)" }}
            >
              Simpan Perubahan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <UsersListPanel title="Supervisor" description="Pantau penempatan cabang, status akun, dan akses supervisor."
        data={listSpv} columns={colSupervisor} {...listState}
        addLabel="Tambah Supervisor" onAdd={(auth.role === "super admin" || auth.role === "admin") ? () => setModalSpv(true) : undefined} />

      <Modal
        size="lg"
        show={modalSpv}
        onHide={() => {
          handleModalClose();
          setModalSpv(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={null}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-user-plus"></i>
              </div>
              Form Tambah Supervisor
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => { handleModalClose(); setModalSpv(false); }} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>NIK</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Form.Control
                        onChange={handleNikChange}
                        value={nik}
                        type="text"
                        placeholder="Masukkan 16 digit NIK"
                        style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0", flex: 1 }}
                      />
                      <span style={{ fontSize: "12px", fontWeight: "600", color: remainingDigits === 0 ? "#16A34A" : "#94A3B8", backgroundColor: remainingDigits === 0 ? "#DCFCE7" : "#F1F5F9", padding: "4px 8px", borderRadius: "20px" }}>
                        {remainingDigits} digit
                      </span>
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Nama Lengkap</label>
                    <Form.Control
                      onChange={(e) => setNama(e.target.value)}
                      placeholder="Masukkan nama lengkap"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={auth.role === "super admin" ? 6 : 12}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>No Karyawan / Username</label>
                    <Form.Control
                      onChange={(e) => setNopeg(e.target.value)}
                      placeholder="Masukkan No Karyawan"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                {auth.role === "super admin" && (
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Client (BPD)</label>
                      <Select
                        classNamePrefix="react-select"
                        value={pilihClient}
                        onChange={(value) => {
                          setPilihClient(value);
                          setIdClientSpv(value.value);
                        }}
                        options={listClient}
                        placeholder="Pilih BPD..."
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "10px",
                            borderColor: "#E2E8F0",
                            padding: "4px",
                            boxShadow: "none",
                            "&:hover": { borderColor: "#0EA5E9" }
                          })
                        }}
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => { handleModalClose(); setModalSpv(false); }}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitSupervisor}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 24px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)" }}
            >
              <i className="fas fa-save mr-2"></i> Simpan Data
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalTambahAkses}
        onHide={() => {
          handleModalClose();
          setModalTambahAkses(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#FDF4FF", padding: "8px", borderRadius: "10px", color: "#C026D3", display: "flex" }}>
                <i className="fas fa-user-shield"></i>
              </div>
              Kelola Akses Supervisor
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => { handleModalClose(); setModalTambahAkses(false); }} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group className="mb-4">
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Akses Baru</label>
                <div style={{ display: "flex", gap: "10px" }}>
                  <Select
                    classNamePrefix="react-select"
                    value={pilihAkses}
                    onChange={(value) => setPilihAkses(value)}
                    options={listAkses}
                    placeholder="Pilih Akses..."
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "10px",
                        borderColor: "#E2E8F0",
                        padding: "2px",
                        boxShadow: "none",
                        "&:hover": { borderColor: "#C026D3" }
                      }),
                      container: (base) => ({
                        ...base,
                        flex: 1
                      })
                    }}
                  />
                  <Button
                    onClick={submitTambahAksesSupervisor}
                    style={{ borderRadius: "10px", fontWeight: "600", padding: "0 20px", backgroundColor: "#C026D3", border: "none", boxShadow: "0 4px 6px rgba(192, 38, 211, 0.2)" }}
                  >
                    Tambah
                  </Button>
                </div>
              </Form.Group>
            </Form>

            <div style={{ marginTop: "24px" }}>
              <h5 style={{ color: "#1E293B", fontWeight: "700", fontSize: "16px", marginBottom: "16px", borderBottom: "1px solid #E2E8F0", paddingBottom: "12px" }}>
                Daftar Akses Saat Ini
              </h5>

              {!aksesUser || aksesUser.length === 0 ? (
                <div style={{ backgroundColor: "#FEF2F2", padding: "16px", borderRadius: "10px", color: "#EF4444", textAlign: "center", fontWeight: "600", fontSize: "14px" }}>
                  <i className="fas fa-exclamation-circle mr-2"></i> User ini belum memiliki akses.
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {aksesUser?.map((akses, index) => (
                    <div key={akses} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", backgroundColor: "#F8FAFC", borderRadius: "10px", border: "1px solid #E2E8F0" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <span style={{ backgroundColor: "#E2E8F0", color: "#475569", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", fontSize: "12px", fontWeight: "700" }}>
                          {index + 1}
                        </span>
                        <span style={{ color: "#1E293B", fontWeight: "600", textTransform: "capitalize" }}>
                          {akses}
                        </span>
                      </div>

                      <OverlayTrigger placement="top" overlay={<Tooltip>Hapus Akses</Tooltip>}>
                        <Button aria-label="Hapus Akses" title="Hapus Akses"
                          variant="light"
                          style={{
                            padding: "6px",
                            borderRadius: "8px",
                            backgroundColor: "#FEF2F2",
                            color: "#EF4444",
                            border: "none",
                            width: "32px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#EF4444";
                            e.currentTarget.style.color = "#FFFFFF";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#FEF2F2";
                            e.currentTarget.style.color = "#EF4444";
                          }}
                          onClick={() => {
                            Swal.fire({
                              icon: "warning",
                              title: `Hapus Akses ${akses}?`,
                              text: "Apakah anda yakin ingin menghapus akses ini?",
                              showCancelButton: true,
                              confirmButtonColor: "#EF4444",
                              cancelButtonColor: "#64748B",
                              confirmButtonText: "Ya, Hapus!",
                              cancelButtonText: "Batal"
                            }).then((result) => {
                              if (result.isConfirmed) {
                                hapusAksesSupervisor({
                                  idSupervisor: idSupervisor,
                                  akses: akses,
                                }).then((response) => {
                                  if (response.status === 200) {
                                    Swal.fire({
                                      icon: "success",
                                      title: "Berhasil",
                                      text: response.data.message,
                                      showConfirmButton: false,
                                      timer: 1500,
                                    });
                                    handleModalClose();
                                    getAllSupervisor(dispatch, { idClient: "" });
                                  } else {
                                    Swal.fire({
                                      icon: "error",
                                      title: "Gagal",
                                      text: response.data.message || "Terjadi kesalahan",
                                    });
                                  }
                                });
                              }
                            });
                          }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </Button>
                      </OverlayTrigger>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Modal.Body>
        </>
      </Modal>
    </>
  );
}

export default ListSupervisor;
